import { Component } from '@angular/core';

@Component({
  selector: 'app-itsm-manufacturing',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [],
})
export class ManufacturingSolution {
  
  constructor() {}

}